
import { Grid, Hidden } from '@mui/material';
import React from 'react';

import '../assets/css/accueil.css'

import agam from '../assets/logo/agam.svg'
import vdm from '../assets/logo/vdm.svg'


const Accueil = () => {

    document.title = "Centres d’intérêt de la filière cinéma/audiovisuel"

    return <Grid container className="accueil1" alignItems="center">
        <Grid item xs={6} sm={3} md={3} lg={2} xl={2}>
            <img src={vdm} alt="AGAM" className={"accueil_vdm"} />
        </Grid>
        <Hidden smUp>
            <Grid item xs={6} sm={3} md={3} lg={2} xl={2}>
                <img src={agam} alt="AGAM" className={"accueil_agam"} />
            </Grid>
        </Hidden>
        <Grid item xs={12} sm={6} md={6} lg={8} xl={8}>
            <div className='accueil_titre'>
                Centres d’intérêt de la filière cinéma/audiovisuel
            </div>
        </Grid>
        <Hidden smDown>

        <Grid item xs={12} sm={3} md={3} lg={2} xl={2}>
            <img src={agam} alt="AGAM" className={"accueil_agam"} />
        </Grid>
        </Hidden>
    </Grid>;
}

export default Accueil;